import { logger } from 'nightingale-app-console/src';
import { stop as stopDisplay } from './commands/display';
import { close as clientClose } from './client';
import { childServer } from './fork-server';

export function exit() {
  logger.warn('exiting...');
  Promise.all([childServer.kill(), stopDisplay(), clientClose()]).then(() => {
    logger.warn('exit !');
    process.exit();
  });
}

process.on('SIGINT', () => {
  exit();
});
